/*
  Validation
 */

var Validation = (function ($) {
  var m = (function () {
    var name = 'Validation';
    var version = '0.0.1';

    /*
      Local variable declarations
    */

    /*
      Handlers
    */
    var handlers = {
      init: function ($select) {
        var options = {
          errorPlacement: function (error, $element) {
            $element.closest('.form__item').append(error);
          },
          highlight: function (element, errorClass, validClass) {
            var $element = $(element);
            $element.addClass(errorClass).removeClass(validClass);

            if ($element.is('select')) {
              $element.data('selectBox-selectBoxIt').dropdownContainer.addClass(errorClass).removeClass(validClass);
            }
          },
          ignore: '.no-validate',
          unhighlight: function (element, errorClass, validClass) {
            var $element = $(element);
            $element.addClass(validClass).removeClass(errorClass);

            if ($element.is('select')) {
              $element.data('selectBox-selectBoxIt').dropdownContainer.addClass(validClass).removeClass(errorClass);
            }
          }
        };

        // Configure options for different select types.
        switch ($select.data('validation-type')) {
        }

        $select.validate(options);
      },
      scrollDown: function () {
        var url = new URL(window.location.href);
        var contactPosted = url.searchParams.get('contact_posted');

        if (contactPosted === 'true') {
          $('html, body').animate({
            scrollTop: $('.page__contact-form').offset().top - $('#shopify-section-header').outerHeight(),
          });
        }
      },
    };

    /*
      List handlers that should be
      accessible in the global namespace
    */
    var publicHandlers = [

    ];

    /*
      Events
    */
    var events = {
      onSubmit: function () {
        $('.js-validate').on('submit', function () {
          var $this = $(this);
          var isValid = $this.valid();

          if (isValid) {
            $this.submit();
          }
          else {
            $this.removeAttr('onsubmit');
            return false;
          }
        });
      },
      pageLoad: function () {
        handlers.scrollDown();

        $('.js-validate').each(function () {
          handlers.init($(this));
        });
      },
    };

    /*
      List events in the order they
      should be bound. Any unlisted
      events will be registered last.
    */
    var eventOrder = [
      'pageLoad',
    ];

    /************************************************************************************
      DON'T EDIT BELOW THIS LINE
    ************************************************************************************/

    var bindEvents = function () {
      var eventNames = Object.keys(events);
      for (var i = 0; i < eventNames.length; i++) {
        var eventName = eventNames[i];
        if (eventOrder.indexOf(eventName) < 0) {
          eventOrder.push(eventName);
        }
      }

      for (var i = 0; i < eventOrder.length; i++) {
        var eventName = eventOrder[i];
        var event = events[eventName];

        if (event !== undefined) {
          if (typeof(event) === 'function') {
            try {
              event();
            }
            catch(e) {
              console.error('Event binding failed: ' + eventName);
              console.error(e);
            }
          }
          else {
            console.error('Event is not a function: ' + eventName);
          }
        }
        else {
          console.error('Event is undefined: ' + eventName);
        }
      }
    };

    var registerPublicHandlers = function () {
      for (var i = 0; i < publicHandlers.length; i++) {
        var handlerName = publicHandlers[i];
        var handler = handlers[handlerName];
        if (handler !== undefined) {
          if (typeof(handler) === 'function') {
            interface[handlerName] = handler;
          }
          else {
            console.error('Handler is not a function: ' + handlerName);
          }
        }
        else {
          console.error('Handler is undefined: ' + handlerName);
        }
      }
    };

    var interface = {
      _init_: function () {
        registerPublicHandlers();
        bindEvents();
        delete interface._init_;
      },
      toString: function () {
        return name + ' (version ' + version + ')';
      },
    };

    return interface;
  }());

  $(function () {
    // Error-safe initialization
    try {
      m._init_();
    }
    catch (e) {
      console.error('Module failed to initialize: ' + m);
      console.error(e);
    }
  });

  return m;
}(jQuery));
